import { render } from "./Exceptions.vue?vue&type=template&id=9f669dd0"
import script from "./Exceptions.vue?vue&type=script&lang=js"
export * from "./Exceptions.vue?vue&type=script&lang=js"

import "./Exceptions.vue?vue&type=style&index=0&id=9f669dd0&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__